import Vue from 'vue'
import Router from 'vue-router'

import Home from '@/components/Home'
import Error from '@/components/Error'
import Packages from '@/components/Packages'
import Activity from '@/components/Activity'
import Overview from '@/components/Overview'
import Stats from '@/components/Stats'
import WhatsNew from '@/components/WhatsNew'

import StandardFrame from '@/components/StandardFrame'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      meta: {
        allowsNavPin: false,
      },
    },
    {
      path: '/error/:errorId',
      name: 'error',
      component: Error,
      meta: {
        allowsNavPin: false,
      },
    },
    {
      path: '/repos/:repoId/',
      component: StandardFrame,
      props: true,
      children: [
        {
          path: 'packages',
          name: 'packages',
          component: Packages,
        },
        {
          path: 'packages/:packageName',
          name: 'package',
          component: Packages,
        },
        {
          path: 'activity',
          name: 'activity',
          component: Activity,
        },
        {
          path: 'overview',
          name: 'overview',
          component: Overview,
        },
        {
          path: 'whats-new',
          name: 'whatsNew',
          component: WhatsNew,
        },
      ],
    },
    {
      path: '/stats/',
      name: 'stats',
      component: Stats,
    },
    {
      path: '*',
      redirect: { name: 'error', params: { errorId: 'routenotfound' } },
    },
  ],
  linkActiveClass: 'active',
})
